import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { pbEngineer } from '../lib/pb';
import EmptyState from '../shared/components/EmptyState';
import Skeleton from '../shared/components/Skeleton';
import { Icons } from '../shared/icons';
import SafeIcon from '../common/SafeIcon';

// Read-only audit trail of captured signatures (spec §1.1). Signatures are
// ONLY captured through the job-sheet completion flow — no capture here.
export default function EngineerSignatures() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [signatures, setSignatures] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const engineerId = pbEngineer.authStore.record?.id;
    if (!engineerId) return;

    pbEngineer.collection('engineer_signatures')
      .getFullList({
        sort: '-signed_at,-created',
        expand: 'engineer_job_id,client_id',
      })
      .then((records) => setSignatures(records))
      .catch((err) => {
        console.error('Failed to load signatures:', err);
        setError('Could not load signatures. Please try again.');
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="page-container"><Skeleton rows={6} /></div>;

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Client Signatures</h1>
        <p>Audit history of captured signatures</p>
      </div>

      {error && <p className="form-hint" style={{ color: '#b91c1c', marginBottom: 12 }}>{error}</p>}

      {signatures.length === 0 ? (
        <EmptyState
          title="No signatures yet"
          message="Signatures are captured when you complete a job — completed job sheets collect a client signature automatically."
          icon={Icons.Pen}
        />
      ) : (
        <div className="signatures-grid">
          {signatures.map((sig) => (
            <div key={sig.id} className="signature-card">
              {sig.signature_data && (
                <img
                  className="sig-image"
                  src={sig.signature_data}
                  alt={`Signature for ${sig.client_name || 'client'}`}
                />
              )}
              <div className="sig-meta">
                <strong>{sig.client_name || sig.expand?.client_id?.name || 'Client'}</strong>
                {sig.expand?.engineer_job_id?.title && (
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => navigate(`../jobs/${sig.engineer_job_id}`, { relative: 'path' })}
                    onKeyDown={(e) => e.key === 'Enter' && navigate(`../jobs/${sig.engineer_job_id}`, { relative: 'path' })}
                    style={{ cursor: 'pointer', color: 'var(--brand-primary)', fontWeight: 600 }}
                  >
                    {sig.expand.engineer_job_id.title}
                  </span>
                )}
                <span>
                  {sig.signed_at
                    ? new Date(sig.signed_at).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })
                    : new Date(sig.created).toLocaleDateString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
